import React, { useState } from 'react';
import DonutChart from '../DonutChart';

// Test component to manually verify DonutChart behavior
export default function DonutChartTest() {
  const [timeWindow, setTimeWindow] = useState('6h');
  
  // Simulate different data scenarios
  const testData = {
    '6h': {
      // 6H window scenario - empty/undefined data
      data: undefined,
      labels: undefined,
      name: '6H Window Test'
    },
    '24h': {
      // Normal data scenario
      data: [30, 20, 50],
      labels: ['Chrome', 'Firefox', 'Safari'],
      name: '24H Window Test'
    },
    'empty': {
      // Empty arrays scenario
      data: [],
      labels: [],
      name: 'Empty Data Test'
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>DonutChart Manual Test</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <button onClick={() => setTimeWindow('6h')}>6H Window</button>
        <button onClick={() => setTimeWindow('24h')}>24H Window</button>
        <button onClick={() => setTimeWindow('empty')}>Empty Data</button>
      </div>

      <div style={{ width: '500px', height: '300px', border: '1px solid #ccc' }}>
        <DonutChart 
          chartData={testData[timeWindow]}
          height={300}
        />
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>Current Test Data:</h3>
        <pre>
          {JSON.stringify(testData[timeWindow], null, 2)}
        </pre>
      </div>
    </div>
  );
}
